import { Tag } from "components/tag";
import { TooltipCircle } from "components/tooltipCircle";
import { TooltipParagraph } from "components/tooltipParagraph";
import { GroupStatusTypes, IEventGroup } from "interfaces";
import moment from "moment";
import { abbreviateNumbers, currencySymbol, formatNumber } from "utills/helpers";

interface EventGroupsTableProps {
  data?: IEventGroup[];
  pageSize: number;
  currentPage: number;
  isLoading: boolean;
  currency?: string;
}

export const EventGroupsTable = ({data = [], isLoading, currentPage, pageSize, currency }: EventGroupsTableProps) => {

  const getGroupStatusText = (statusType: GroupStatusTypes) => {
    switch (statusType) {
      case GroupStatusTypes.CANCELED: return "Canceled";
      case GroupStatusTypes.CLOSED: return "Closed";
      case GroupStatusTypes.OPENING: return "Opening";
      case GroupStatusTypes.SENDPAYMENT: return "Send Payment";
      case GroupStatusTypes.SUCCESS: return "Success";
      default: return "";
    }
  }

  return (
    <div className="flow-root">
      <div className="relative inline-block w-full align-middle box-border">
        <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th
                scope="col"
                className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8"
              >
                No
              </th>
              <th scope="col" className="th">
                Group name
              </th>
              <th scope="col" className="th">
                Members
              </th>
              <th scope="col" className="th">
                Paid
              </th>
              <th scope="col" className="th">
                Gross revenue
              </th>
              <th scope="col" className="th">
                Discount
              </th>
              <th scope="col" className="th">
                Net revenue
              </th>
              <th scope="col" className="th">
                Expired date time
              </th>
              <th scope="col" className="th">
                Status <TooltipCircle text={`Opening: Registration is open. \nSend payment: The group leader has sent a payment request. \nSuccess: When the payment is successful. \nClosed: Group registration expired.`} />
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
          {(!isLoading) ? data.map((item: IEventGroup, index: number) => (
              <tr key={index}>
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  {(currentPage - 1) * pageSize + 1 + index}
                </td>
                <td className="td max-w-10 overflow-x-auto">
                  <TooltipParagraph 
                    text={item.name}
                    className="whitespace-pre-wrap max-w-[280px]"
                  />
                </td>
                <td className="td overflow-x-auto capitalize">
                  <span
                    data-tooltip-id="tooltip"
                    data-tooltip-content={formatNumber(item.attendant_quantity)}
                  >
                    {abbreviateNumbers(item.attendant_quantity)}
                  </span>
                </td>
                <td className="td overflow-x-auto">
                  <span
                    data-tooltip-id="tooltip"
                    data-tooltip-content={formatNumber(item.attendant_paid_quantity)}
                  >
                    {abbreviateNumbers(item.attendant_paid_quantity)}
                  </span>
                </td>
                <td className="td overflow-x-auto">
                  <span
                    data-tooltip-id="tooltip"
                    data-tooltip-content={formatNumber(item.total_amount)}
                  >
                    {currencySymbol(currency)} {abbreviateNumbers(item.total_amount)}
                  </span>
                </td>
                <td className="td overflow-x-auto">
                  <span
                    data-tooltip-id="tooltip"
                    data-tooltip-content={formatNumber(item.discount_amount)}
                  >
                    {currencySymbol(currency)} {abbreviateNumbers(item.discount_amount)}
                  </span>
                </td>
                <td className="td overflow-x-auto">
                  <span
                    data-tooltip-id="tooltip"
                    data-tooltip-content={formatNumber(item.final_amount)}
                  >
                    {currencySymbol(currency)} {abbreviateNumbers(item.final_amount)}
                  </span>
                </td>
                <td className="td overflow-x-auto">
                  {item.expired_date ? moment(item.expired_date).format("DD/MM/YYYY HH:mm:ss") : ""}
                </td>
                <td className="td overflow-x-auto">
                  <Tag text={getGroupStatusText(item.group_status)} type={item.group_status}  />
                </td>
              </tr>
            )) 
            : Array(10).fill(null).map((item: any, index: number) => (
              <tr key={index} className="h-[57px]">
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td max-w-40 overflow-x-auto">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
                <td className="td">
                  <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                </td>
              </tr>
            ))}
            {data.length === 0 && !isLoading ? (
              <tr>
                <td colSpan={10} className="td">
                  <div className="text-center">
                    No data
                  </div>
                </td>
              </tr>
            ) : <></>}
          </tbody>
        </table>
      </div>

    </div>

  )
}